import { reactive } from "vue"
import { createRouter, createWebHistory } from "vue-router"
import { authGuard } from "@auth0/auth0-vue"
import Overview from "@/views/Overview.vue"
import { nonPartnerGuard, permissionGuard, roleGuard } from "./guards.js"

const routes = () => ([
  {
    path: "/:pathMatch(.*)*",
    redirect: "/overview",
  },
  {
    path: "/overview",
    name: "overview",
    component: Overview,
    beforeEnter: [authGuard, nonPartnerGuard],
    children: [
      {
        path: "",
        name: "overview-default",
        component: () => import("@/views/OverviewCards.vue"),
        beforeEnter: roleGuard(["direct_reseller", "involved_reseller"], "/overview/table"),
      },
      {
        path: "table",
        name: "table",
        component: () => import("@/views/OverviewTable.vue"),
      },
    ],
  },
  {
    path: "/manage-subscription/:id",
    name: "manageSubscription",
    component: () => import("@/views/ManageSubscription.vue"),
    beforeEnter: [authGuard, nonPartnerGuard, permissionGuard("manageSubscription")],
    props: ({ params }) => ({ id: params.id }),
  },
  {
    path: "/manage-instance/:id",
    name: "manageInstance",
    component: () => import("@/views/ManageInstance.vue"),
    beforeEnter: [authGuard, nonPartnerGuard, permissionGuard("manageInstance")],
    props: ({ params }) => ({ id: params.id }),
  },
  {
    path: "/account",
    name: "account",
    component: () => import("@/views/Account.vue"),
    beforeEnter: [authGuard, nonPartnerGuard],
  },
  {
    path: "/invoices",
    name: "invoices",
    component: () => import("../views/Invoice.vue"),
    beforeEnter: [authGuard, nonPartnerGuard, roleGuard(["distributor", "direct_reseller"])],
    props: ({ query }) => ({
      instance: query.instance,
      year: query.year,
    }),
  },
  {
    path: "/no-partner",
    name: "noPartner",
    component: () => import("@/views/NoPartner.vue"),
    beforeEnter: authGuard,
  },
  {
    path: "/no-permission",
    name: "noPermission",
    component: () => import("@/views/NoPermission.vue"),
    beforeEnter: authGuard,
  },
  {
    path: "/upload",
    name: "UploadSelect",
    component: () => import("@/views/SubscriptionSelectSkeleton.vue"),
    props: () => ({
      icon: "$mdiFileUpload",
      header: "file upload",
    }),
    beforeEnter: [authGuard, nonPartnerGuard],
    children: [
      {
        path: ":id",
        name: "Upload",
        props: ({ params }) => ({ id: params.id }),
        component: () => import("@/views/InstanceProgressSkeleton.vue"),
        beforeEnter: permissionGuard("uploadFiles"),
        children: [
          {
            path: "",
            name: "upload-default",
            component: () => import("@/views/Upload.vue"),
            props: ({ params }) => ({ id: params.id }),
          },
        ],
      },
    ],
  },
  {
    path: "/multi-platform-probe",
    name: "MultiPlatformProbeSelect",
    component: () => import("@/views/SubscriptionSelectSkeleton.vue"),
    props: () => ({
      icon: "$mdiRouterNetwork",
      header: "multi-platform probe",
    }),
    beforeEnter: [authGuard, nonPartnerGuard],
    children: [
      {
        path: ":id",
        name: "MultiPlatformProbe",
        props: ({ params }) => ({ id: params.id }),
        component: () => import("@/views/InstanceProgressSkeleton.vue"),
        beforeEnter: permissionGuard("manageInstance"),
        children: [
          {
            path: "",
            name: "multi-platform-probe-default",
            component: () => import("@/views/MultiPlatformProbe.vue"),
            props: ({ params }) => ({ id: params.id }),
          },
        ],
      },
    ],
  },
])

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes(),
})

const state = reactive({
  loading: false,
})
router.state = state

router.beforeEach((_, __, next) => {
  state.loading = true
  return next()
})
router.afterEach(() => {
  state.loading = false
})

export default router
export {
  routes,
}
export * from "./guards"
